const swea = require('swea');
const ResolutionInteraction = swea.editor.interactions.ResolutionInteraction;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const ViewerManager = swea.editor.ViewerManager;
const InteractionManager = swea.editor.InteractionManager;
const ContextMenuStateServiceActions = swea.react.actions.ContextMenuStateServiceActions;
const MeasureServiceActions = swea.react.actions.MeasureServiceActions;
import * as globals from '../globals';

class CustomResolutionInteraction extends ResolutionInteraction {
  /**
   * The constructor.
   * @param { object } options An option object, see {@link ResolutionInteraction} for more info.   
   */
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }
  
  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId){
    super.initialize(element, viewerId);

    // When user closes the tool
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      }
    ));
  }
  
  _beforeCalculating() {
    this.getViewer().setCursor('wait');
  }

  _whenCalculated(textureResolution, pixelTexelRelation, imageResolution) {
    this.getViewer().setCursor('crosshair');
    MeasureServiceActions.setPickedResolutions(textureResolution, pixelTexelRelation, imageResolution);
  }

  whenInitialized(element, viewerId) {
    super.whenInitialized(element, viewerId);
    
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.RESOLUTION_ACTIVATED
    );
    
    this._disabledInteractionClasses = InteractionManager.instance().disableContinuousInteractions();
    ViewerManager.instance().getViewerById(viewerId).setCursor('crosshair');
    InstructionServiceActions.showInstruction('instructions.resolution_interaction');
  }
  
  whenTerminated(element, viewerId){
    super.whenTerminated(element, viewerId);
    
    ContextMenuStateServiceActions.closeContextMenu(
      globals.LOWER_CONTEXT_MENU
    );

    ViewerManager.instance().getViewerById(viewerId).setCursor('default');
    InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    InstructionServiceActions.hideInstruction();
  }
}
export default CustomResolutionInteraction;
